var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8556 15.6659C37.8556 21.2737 33.4487 25.8198 28.0125 25.8198C22.5763 25.8198 18.1694 21.2737 18.1694 15.6659C18.1694 10.058 22.5763 5.51196 28.0125 5.51196C33.4487 5.51196 37.8556 10.058 37.8556 15.6659Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7871 38.9515C10.7871 33.3437 15.194 28.7976 20.6302 28.7976H35.3948C40.831 28.7976 45.2379 33.3437 45.2379 38.9515C45.2379 44.5594 40.831 49.1054 35.3948 49.1054H20.6302C15.194 49.1054 10.7871 44.5594 10.7871 38.9515Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.66a280e5661942eee5800a50d6cbbbf3.svg";
export { ForwardRef as ReactComponent };